import { ThemeProvider } from "@mui/material";
import Principal from "./pages/Principal";
import Loading from "./pages/Loading";
import NotFound from "./pages/NotFound";
import { configureDesignSystem } from "./theme/designTheme";
import { useListenerData } from "./hooks/useListenerData";

function App() {
  const { data, isError, isLoading } = useListenerData();

  const theme = configureDesignSystem(data?.general || {});

  return (
    <ThemeProvider theme={theme}>
      {isLoading ? (
        <Loading />
      ) : isError ? (
        <NotFound />
      ) : (
        <Principal data={data!} />
      )}
    </ThemeProvider>
  );
}

export default App;
